export const GET_RETAIL_PLAN_INPUTS_SUCCESS = 'GET_RETAIL_PLAN_INPUTS_SUCCESS';
export const GET_RETAIL_PLAN_INPUTS_ERROR = 'GET_RETAIL_PLAN_INPUTS_ERROR';
export const GET_RETAIL_PLAN_INPUTS = 'GET_RETAIL_PLAN_INPUTS';
export const UPDATE_RETAIL_MASTER_PLAN_INPUTS =
  'UPDATE_RETAIL_MASTER_PLAN_INPUTS';
export const GET_RETAIL_PRODUCTION_PLAN_TAB_METADATA =
  'GET_RETAIL_PRODUCTION_PLAN_TAB_METADATA';
export const GET_RETAIL_PRODUCTION_PLAN_TAB_METADATA_SUCCESS =
  'GET_RETAIL_PRODUCTION_PLAN_TAB_METADATA_SUCCESS';
